export default __webpack_public_path__ + "static/media/DME Task Priorities and Timeframes.1e8c4312.pdf";